if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event) => {
          this.expandShowMore(event);
        });
      }

      getList(parentDisplay) {
        return (
          parentDisplay.querySelector('.facets__list--vertical') ||
          parentDisplay.querySelector('ul')
        );
      }

      lockListHeight(list, height) {
        list.style.maxHeight = `${height}px`;
        list.style.overflowY = 'auto';
        list.classList.add('is-expanded-scroll');
        this.mountPersistentScrollbar(list, height);
      }

      mountPersistentScrollbar(list, height) {
        if (list.parentElement?.classList.contains('facets-scroll-shell')) {
          this.updatePersistentScrollbar(list);
          return;
        }

        const shell = document.createElement('div');
        shell.className = 'facets-scroll-shell';
        shell.style.setProperty('--facets-list-collapsed-height', `${height}px`);
        list.parentNode.insertBefore(shell, list);
        shell.appendChild(list);

        const rail = document.createElement('span');
        rail.className = 'facets-scroll-rail';
        const thumb = document.createElement('span');
        thumb.className = 'facets-scroll-thumb';
        rail.appendChild(thumb);
        shell.appendChild(rail);

        const update = () => this.updatePersistentScrollbar(list);
        list.addEventListener('scroll', update, { passive: true });
        requestAnimationFrame(update);
      }

      updatePersistentScrollbar(list) {
        const shell = list.parentElement;
        const thumb = shell?.querySelector('.facets-scroll-thumb');
        if (!thumb) return;

        const { scrollHeight, clientHeight, scrollTop } = list;
        const thumbHeight = Math.max(24, (clientHeight / scrollHeight) * clientHeight);
        const maxTop = Math.max(0, clientHeight - thumbHeight);
        const top =
          scrollHeight > clientHeight
            ? (scrollTop / (scrollHeight - clientHeight)) * maxTop
            : 0;

        thumb.style.height = `${thumbHeight}px`;
        thumb.style.transform = `translateY(${top}px)`;
      }

      expandShowMore(event) {
        const trigger = event.target.closest('[id^="Show-More-"]') || this.querySelector('button');
        const parentDisplay = trigger?.closest('.parent-display') || this.closest('.parent-display');
        if (!parentDisplay) return;

        const list = this.getList(parentDisplay);
        if (list) {
          const collapsedHeight = list.clientHeight;
          parentDisplay.style.setProperty('--facets-list-collapsed-height', `${collapsedHeight}px`);
          parentDisplay.classList.add('is-showing-more');
          this.lockListHeight(list, collapsedHeight);
        }

        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.remove('hidden'));
        this.classList.add('hidden', 'is-expanded');
        this.setAttribute('aria-hidden', 'true');
        if (list) requestAnimationFrame(() => this.updatePersistentScrollbar(list));
      }
    }
  );
}
